import CollapseButton from "../atoms/CollapseButton";
import ActionButton from "../atoms/ActionButton";

/**
 * ShopRow - 店舗1行分の表示（ShopManagementList から独立させた molecule）
 *
 * 店舗行 + 展開時のレジ一覧（アクティブ・無効化済み）をまとめて描画する。
 *
 * @param {object}   shop       - 店舗データ（registers: レジ一覧を含む）
 * @param {boolean}  isExpanded - レジ一覧の展開状態
 * @param {function} onToggle   - 展開/折りたたみ切り替えハンドラ
 * @param {function} onEdit     - 「編集」ボタン押下ハンドラ
 */
function ShopRow({ shop, isExpanded, onToggle, onEdit }) {
  const activeRegiList   = (shop.registers || []).filter((r) => r.IsActive === 1);
  const inactiveRegiList = (shop.registers || []).filter((r) => r.IsActive !== 1);

  return (
    <>
      {/* 店舗行 */}
      <tr className="border-b border-gray-200 hover:bg-gray-50">
        <td className="py-2 pr-2">
          <CollapseButton isExpanded={isExpanded} onToggle={onToggle} />
        </td>
        <td className="py-2 pr-4 text-gray-400 text-base">{shop.ShopNo}</td>
        <td className="py-2 pr-4 font-medium">{shop.ShopName}</td>
        <td className="py-2 pr-4 text-gray-600">{shop.BuildingName || "—"}</td>
        <td className="py-2 pr-4 text-gray-500 text-base">
          （所属レジ：{activeRegiList.length}）
        </td>
        <td className="py-2">
          <ActionButton
            label="編集"
            onClick={onEdit}
            paddingClass="px-5 py-1"
            textSizeClass="text-base font-medium"
          />
        </td>
      </tr>

      {/* レジ一覧（展開時） */}
      {isExpanded && (
        <tr className="border-b border-gray-100">
          <td colSpan={6} className="pb-3 pl-10 pr-4">
            {/* アクティブなレジ */}
            {activeRegiList.length === 0 ? (
              <p className="text-gray-400 text-base py-1">
                レジが登録されていません。
              </p>
            ) : (
              <table className="w-full text-base border-collapse table-fixed">
                <thead>
                  <tr className="text-left text-gray-400 text-base">
                    <th className="py-1 pr-4 font-normal w-[10%]">No.</th>
                    <th className="py-1 pr-4 font-normal w-[30%]">レジ部門名</th>
                    <th className="py-1 pr-4 font-normal w-[30%]">担当者</th>
                    <th className="py-1 font-normal w-[30%]">ログインID</th>
                  </tr>
                </thead>
                <tbody>
                  {activeRegiList.map((r) => (
                    <tr key={r.RegiNo} className="border-t border-gray-100">
                      <td className="py-1 pr-4 text-gray-400">{r.RegiNo}</td>
                      <td className="py-1 pr-4">{r.RegiName}</td>
                      <td className="py-1 pr-4 text-gray-600">{r.UserName}</td>
                      <td className="py-1 text-gray-600">{r.UserID}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* 無効化済みのレジ */}
            {inactiveRegiList.length > 0 && (
              <div className="mt-3">
                <p className="text-sm text-gray-400 mb-1">無効化済みのレジ（復旧が必要な場合は開発者にご連絡ください）</p>
                <table className="w-full text-base border-collapse table-fixed">
                  <tbody>
                    {inactiveRegiList.map((r) => (
                      <tr key={r.RegiNo} className="border-t border-gray-100">
                        <td className="py-1 pr-4 text-gray-300 w-[10%]">{r.RegiNo}</td>
                        <td className="py-1 pr-4 text-gray-400 w-[30%]">{r.RegiName}</td>
                        <td className="py-1 pr-4 text-gray-300 w-[30%]">{r.UserName}</td>
                        <td className="py-1 text-gray-300 w-[30%]">{r.UserID}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </td>
        </tr>
      )}
    </>
  );
}

export default ShopRow;
